const styles = ({ palette }) => ({
  dialogTitle: {
    zIndex: 2,
    color: palette.text.primary,
  },
  dialogContent: {
    padding: 0,
    '.MuiDialogTitle-root + &': { 
      paddingTop: 0,
    },    
  },
  iFrame: {
    opacity: 1,
    width: '100%',
    height: '100%',
  },
});

export default styles;
